import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import CustomCKEditor, { cleanHtmlForSave } from "Components/CustomCKEditor";
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
import parse from 'html-react-parser';
import '../../css/fillInBlanks.scss'; // Import the CSS file
import GradingDropdown from "../../GradeSubmission/GradingDropdown";
import httpService from 'services/httpService.js';
import * as constants from "Constants";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import AnswerExplanation from "../../GradeSubmission/AnswerExplaination";
import GradeCheck from "../../GradeSubmission/GradeCheck";
// import { renderToString } from 'react-dom/server';
import {removeRemarks} from "../../GradeSubmission/GradeCheck";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { FiColumns } from "react-icons/fi";
import log from "loglevel";


function Subjective(props) {
  const { courseId, question, index, previousResponse, updateResponse, disable, Eval, showMarksToStudent } = props;
  const params = useParams();
  const courseIdParam = params.courseId || courseId;
  const labIdParam = params.labId || props.labId;
  const activityIdParam = params.activityID || question?.otherlab;
  const [questionResponseId, setQuestionResponseId] = useState(null);
  const [subj_text, setSubj_Text] = useState("");
  // Track if user has made changes (to avoid saving on initial load)
  const hasUserEdited = useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const userInfo = useSelector(state => state?.userInfo);
  const mode = userInfo.mode;

  // Refs to always access the latest values (fixes stale closure issue)
  const disableRef = useRef(disable);
  const questionResponseIdRef = useRef(questionResponseId);
  const updateResponseRef = useRef(updateResponse);

  // Keep refs in sync with state/props
  useEffect(() => {
    disableRef.current = disable;
  }, [disable]);

  useEffect(() => {
    questionResponseIdRef.current = questionResponseId;
  }, [questionResponseId]);

  useEffect(() => {
    updateResponseRef.current = updateResponse;
  }, [updateResponse]);

  useEffect(() => {
    if (previousResponse && !questionResponseId) {
      setQuestionResponseId(previousResponse.id);
      setSubj_Text(previousResponse.response_text); // Set subj_text with previous response text
    }
  }, [previousResponse]);

  const storeResponses = (text) => {
    // Per-question API call removed — local state only. Autosave runs every
    // 30s in student/index.jsx and on Submit Quiz, batching all answers into
    // one POST .../student_submission/?autosave=true.
    const currentDisable = disableRef.current;
    if (currentDisable) return;

    const cleanedHtml = cleanHtmlForSave(text);
    updateResponseRef.current({
      ...(previousResponse || {}),
      id: question?.id,
      response_text: cleanedHtml,
    });
  }

  const typingHandler = ({text, html}) => {
    hasUserEdited.current = true;
    setSubj_Text(html);
    storeResponses(html);
  }

  // const storeRemark = async (remark) => {
  //   const _response = await actions.addRemarkRequest(question, questionResponseId, remark);
  //   updateResponse();
  // }

  const storeScoredMarks = async (scored_marks) => {
    const response = await actions.addScoredMarksRequest(question, questionResponseId, scored_marks);
    updateResponse();
  }
  const handleSave = async (data) => {
    log.log('Grading Data:', data);
    if (data.marks > question?.marks) {
      displayGlobalMessage(`Question Grading failed: Invalid input: marks can't exceed ${question?.marks}`, 'error');
      return;
    } else {
      let url = constants.base_url + "/lab/activity/";
      let loc = location.pathname;
      let urlArray = loc.split('/');
      let user = userInfo.name || userInfo.username;
      let grade_data = {
        ...data,
        graded_by: user,
        question: question?.id,
        student_id: urlArray[urlArray.length - 1],
        otherlab: question?.otherlab,
        graded: true
      };
      log.log('graded data', grade_data);
      url = url + urlArray[urlArray.length - 3] + "?type=other_type_grade_submission";
      
      try {
        const response = await httpService.put(url, grade_data);
        log.log('response data:', response);
        if (response.status === 200) {
          displayGlobalMessage('Question Graded Successfully', 'success');
        } else {
          displayGlobalMessage('Question Grading failed', 'error');
        }
      } catch (error) {
        displayGlobalMessage('Question Grading failed', 'error');
        log.error(error);
      } finally {
        location.reload();
      }
    }
  };
  
  const q_text=removeRemarks(question?.question_text)
  return (
    <Row className="fill-blanks-component" style={{ margin: 10, position: 'relative' }}>
     <Col xs={12} style={{marginBottom: 10}}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', borderBottom: '1px solid #ddd' }}>
    <b><i><span style={{fontSize:20, color: 'rgb(41, 121, 255)'} }>{`Question ${index + 1}`}</span></i></b>
    <span style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'rgb(41, 121, 255)' }}>
    <i>Question Type: {question.question_type == 'D' ? 'Subjective' : question.question_type == 'T' ? 'Text' : ''} <span style={{ marginLeft: '40px' }}>Marks: {question.marks}{question.negative_marks ? `, Negative: ${question.negative_marks % 1 === 0 ? Math.floor(question.negative_marks) : question.negative_marks}` : ''}</span></i>
    </span>
  </div>
</Col>
<Col xs={12}>
  <div className="question-text">{parse(q_text)}</div>
</Col>

      <Col xs={12}>
        <div disabled={disable} style={(Eval || question?.questionresponse_set?.graded) ? {border: (question?.marks === question?.questionresponse_set?.scored_marks)? '2px solid green' : (question?.questionresponse_set?.scored_marks>0)? '2px solid orange' : '2px solid red',backgroundColor: question?.marks === question?.questionresponse_set?.marks ? '#b9eddd' : '', overflow: 'hidden' }: {}}>
          <CustomCKEditor
            onChange={({text, html}) => typingHandler({text, html})}
            value={subj_text}
            disabled={disable || mode === "I"}
            placeholder="Enter your answer here..."
            config={mode === "I" ? {
              toolbar: [],
              resize_enabled: false,
              height: 400
            } : {
              toolbar: [
                { name: 'document', items: ['Source', 'Save', 'Markdown'] },
                { name: 'styles', items: ['Format', 'FontSize', 'Font'] },
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                { name: 'links', items: ['Link'] },
                { name: 'insert', items: ['Image', 'image2', 'Table', 'HorizontalRule', 'texzilla', 'CodeSnippet'] },
                { name: 'colors', items: ['TextColor', 'BGColor'] },
                { name: 'about', items: ['About'] }
              ],
              resize_enabled: false,
              height: 400
            }}
          />
        </div>
      </Col>
      {(disable === true && showMarksToStudent !== false) ?
        <>
          <Col xs={6}>
            {mode !== "I" && question?.questionresponse_set?.graded && (() => {
              const qr = question.questionresponse_set;
              const gradedBy = qr.graded_by && qr.graded_by !== 'NA' && qr.graded_by !== 'None' ? qr.graded_by : '-';
              const gradedOn = qr.graded_on ? new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).format(new Date(qr.graded_on)).replace(/\s?(am|pm)\b/i, (m, p) => ' ' + p.toUpperCase()) : '-';
              const remark = qr.remark && qr.remark !== 'None' ? qr.remark : '';
              return (
                <div style={{ marginTop: 28, padding: '10px 14px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 13, color: '#374151' }}>
                  {remark && (
                    <div><strong>Remark:</strong> {remark}</div>
                  )}
                  <div style={{ marginTop: remark ? 4 : 0 }}>
                    <strong>Graded by:</strong> {gradedBy}
                    {qr.graded_on && <> ({gradedOn})</>}
                  </div>
                </div>
              );
            })()}
          </Col>
          <Col xs={6}>
            <Form.Group>
              <Form.Label>Scored Marks</Form.Label>
              <Form.Control type="number" min='0' value={(Eval || mode === "I" || question?.questionresponse_set?.graded) ? question?.questionresponse_set?.scored_marks : 0} step='0.1' disabled />
            </Form.Group>
            {mode !== "I" && (question?.questionresponse_set?.graded || Eval) && (
              <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
                <Link
                  to={`/courseware/course/${courseIdParam}/content/labs/${labIdParam}/other/${activityIdParam}/SubjectiveGrading/${question.id}`}
                  className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1"
                  style={{ textDecoration: 'none', fontWeight: 500 }}
                >
                  <FiColumns size={15} />
                  <span>View Rubric Grading</span>
                </Link>
              </div>
            )}
            {mode === "I" && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ marginRight: '-100px', marginTop: '-40px', marginLeft: '-250px' }}>
                  <GradingDropdown onSave={handleSave} />
                </div>
                <div style={{ marginRight: '-100px', marginTop: '-40px', marginLeft: '-450px' }}>
                  <AnswerExplanation explanation={question?.answer_explaination} />
                </div>
              </div>
            )}
          </Col>
        </>
        :
        <></>
      }
      {/* Saving indicator - bottom left */}
      {isSaving && (
        <div className="saving-indicator">
          Saving<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span>
        </div>
      )}
    </Row>
  );
};

export default Subjective;
